import {
    ENVIRONMENT_DEV,
    ENVIRONMENT_DEV_API_URL,
    ENVIRONMENT_DEV_CDN_URL,
    ENVIRONMENT_PROD,
    ENVIRONMENT_PROD_API_URL,
    ENVIRONMENT_PROD_CDN_URL,
    ENVIRONMENT_TEST,
    ENVIRONMENT_TEST_API_URL,
    ENVIRONMENT_TEST_CDN_URL,
} from '../constants';
import { TLoadComgateCheckoutConfig, TPreloadComgateCheckoutConfig } from '../types';
import { resolveEnvironment } from './resolveEnvironment';

export const resolveUrl = (config: TLoadComgateCheckoutConfig | TPreloadComgateCheckoutConfig, type: 'api' | 'cdn'): string => {
    const env = resolveEnvironment(config);

    if (type === 'cdn') {
        return {
            [ENVIRONMENT_DEV]: ENVIRONMENT_DEV_CDN_URL,
            [ENVIRONMENT_TEST]: ENVIRONMENT_TEST_CDN_URL,
            [ENVIRONMENT_PROD]: ENVIRONMENT_PROD_CDN_URL,
        }[env];
    }

    return {
        [ENVIRONMENT_DEV]: ENVIRONMENT_DEV_API_URL,
        [ENVIRONMENT_TEST]: ENVIRONMENT_TEST_API_URL,
        [ENVIRONMENT_PROD]: ENVIRONMENT_PROD_API_URL,
    }[env];
};
